import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { DemographicWidgetsType } from '../../types'

const DemographicTopicInaccessibleGuard: WidgetGuard = ({ widgetId, children }) => {
  const { selectedTopic } = useDashboardWidgetSetting<DemographicWidgetsType>(widgetId)
  const { t } = useTranslation()
  // * for case after creating demogrphic, delete topic
  if (!selectedTopic) {
    return <ErrorMessage>{t('topicInaccessible')}</ErrorMessage>
  }
  return children
}

export default DemographicTopicInaccessibleGuard
